// @flow
import { connect } from 'react-redux';

import type { State } from 'types/redux';
import PhoneTextField, { type Props } from './PhoneTextField';

import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  countryCode: getDealerCountryCode(state)
});

export default connect(mapStateToProps)(PhoneTextField);



// WEBPACK FOOTER //
// ./src/components/api/containers/PhoneTextField/PhoneTextFieldContainer.js